import {AbSelectOption} from "@/scripts/components/ab-select/ab-select.types";
import {ProductNameResponseItemDTO} from "@shared/DTO";
import {normalizeString} from "@/scripts/utils/string.utils";

export function filterOptionsByTerm(
  term: string,
  options: AbSelectOption[],
  products:  ProductNameResponseItemDTO[]
): AbSelectOption[] {
  const normalizedSearchInput = normalizeString(term);
  return options.filter( ({id}) => {
    const productNames = products.find( p => p._id === id)?.productData?.names || [];
    return productNames
      .some( name =>
        normalizeString(name)?.includes(normalizedSearchInput)
      );
  });
}